const ACCOUNT_HASH =
  (import.meta.env.VITE_CF_IMAGES_ACCOUNT_HASH as string | undefined) ??
  'REPLACE_WITH_CF_IMAGES_ACCOUNT_HASH';

export function cloudflareImageUrl(imageId: string, variant = 'public'): string {
  return `https://imagedelivery.net/${ACCOUNT_HASH}/${imageId}/${variant}`;
}

export function isCloudflareImageRef(src: string): boolean {
  return src.startsWith('cfimg:');
}

export function resolveImageSrc(src: string, variant = 'public'): string {
  if (isCloudflareImageRef(src)) {
    return cloudflareImageUrl(src.slice('cfimg:'.length), variant);
  }
  return src;
}
